import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../elements/Footer';
import Box from '../atoms/Box';
import { LandingPageHeader } from '../elements/LandingPageHeader';
import { useRouter } from '../../utils/router';

const LandingPageLayout = ({ children }) => {
  const history = useRouter();

  return (
    <>
      <div className={'App content'} id="main" data-cy={`${history.pathname}`}>
        <LandingPageHeader />
        <Box pt="56px" pl={{ _: 0, lg: 0 }} bg="white">
          <Box minHeight={'100vh'} margin="auto">
            {children}
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};
LandingPageLayout.propTypes = {
  children: PropTypes.node
};

export default LandingPageLayout;
